import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { api } from '@/api'
import Button from '@/components/Button'
import PlayButton from '@/components/Button/PlayButton'
import Container from '@/components/Container'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import Section from '@/components/Section'
import Title from '@/components/Title'
import React, { useState } from 'react'
import style from '../styles/reviews.module.scss'
import { IFetcherListResults } from '@/interfaces/Fetcher'

const VideoReviews = (): React.ReactElement => {
  const [playVideo, setPlayVideo] = useState('')

  return (
    <Section>
      <FetcherList
        initFilter={{ page_size: 2 }}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getVideoReviews}
      >
        {({
          results,
          status,
          showMore,
          isNext
        }: IFetcherListResults<any[]>) => {
          return (
            <Container>
              <Title type='h2' theme='h1' className={style.reviews__title}>
                Видеообзоры
              </Title>

              <ul className={style.reviews_list}>
                {results.map(el => {
                  return (
                    <li key={el.id} className={style.reviews__item}>
                      {playVideo === `video_review_${String(el.id)}`
                        ? (
                          <video
                            width='400px'
                            height='300px'
                            controls
                            controlsList='nodownload'
                            autoPlay
                            className={style.reviews_card_video}
                          >
                            <source
                              src={el.property_video_value?.[0]}
                              type='video/mp4'
                            />
                          </video>
                          )
                        : (
                          <>
                            <img
                              src={el.preview_picture?.[0] ?? ''}
                              width='560px'
                              height='311'
                              alt={el.name}
                              className={style.reviews_card_preview}
                            />
                            <div className={style.reviews_card_button_positioner}>
                              <PlayButton
                                onClick={() => {
                                  setPlayVideo(`video_review_${String(el.id)}`)
                                }}
                              />
                            </div>
                            <div
                              title={el.name}
                              className={style.reviews_card_content}
                            >
                              <span className={style.reviews_card_title}>
                                {el.name}
                              </span>
                            </div>
                          </>
                          )}
                    </li>
                  )
                })}
                {status === dataStates.loading
                  ? (
                    <>
                      <li className={style.reviews__item}>
                        <PlaceholderLoading
                          shape='rect'
                          width='100%'
                          height='100%'
                        />
                      </li>
                      <li className={style.reviews__item}>
                        <PlaceholderLoading
                          shape='rect'
                          width='100%'
                          height='100%'
                        />
                      </li>
                    </>
                    )
                  : null}
              </ul>

              {isNext
                ? (
                  <Button
                    disabled={status === dataStates.loading}
                    onClick={showMore}
                    size='large'
                    wide
                    outline
                    className={style.reviews__more}
                  >
                    Показать еще
                  </Button>
                  )
                : null}
            </Container>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default VideoReviews
